import { XSRF_HEADER_NAME, xsrfTokenRequester } from '@economic/http-client';

export const fetchXsrfTokenHeaders = async () => {
    const xsrftoken = await xsrfTokenRequester(process.env.ECONOMIC_PATH);
    return {
        headers: {
            [XSRF_HEADER_NAME]: xsrftoken,
        },
    };
};
